import { Sizes } from "../../constants/size";
import type { IconProps } from "../../types/icon-props";

export const Instagram = (props: IconProps) => {
  const {
    size = "md",
    fill = "var(--grey-1)",
    stroke = "var(--grey-1)",
    ...rest
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 33 32"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#clip0_9813_210)">
        <path
          d="M14.1427 0.946167L11.2027 0.16716C8.5667 -0.53284 5.86269 1.03616 5.16269 3.67216L4.42969 6.44016C6.84869 3.43716 10.3227 1.47217 14.1427 0.946167Z"
          fill="#32323C"
        />
        <path
          d="M1.26552 18.356L0.547531 21.063C-0.152469 23.699 1.41654 26.403 4.05254 27.103L6.85252 27.85C3.86352 25.5 1.86852 22.11 1.26552 18.356Z"
          fill="#32323C"
        />
        <path
          d="M28.5986 4.78227L25.4336 3.94727C28.6396 6.41327 30.7246 10.0613 31.2216 14.0763L32.0846 10.8093C32.7776 8.18327 31.2206 5.49127 28.5986 4.78227Z"
          fill="#32323C"
        />
        <path
          d="M18.4316 30.9264L21.4426 31.7264C24.0786 32.4254 26.7826 30.8554 27.4816 28.2194L28.3316 25.0264C25.9386 28.2224 22.3806 30.3424 18.4316 30.9264Z"
          fill="#32323C"
        />
        <path
          d="M16.3164 2.19141C8.67741 2.18941 2.48442 8.3814 2.48242 16.0204C2.48242 16.0224 2.48242 16.0234 2.48242 16.0244C2.48342 23.6634 8.67542 29.8564 16.3144 29.8554C16.3154 29.8554 16.3154 29.8554 16.3164 29.8554C23.9544 29.8544 30.1454 23.6624 30.1464 16.0244C30.1464 8.3854 23.9554 2.19241 16.3164 2.19141ZM8.48343 9.09241C8.89743 6.95141 10.9674 5.54941 13.1094 5.96141C15.2524 6.37441 16.6544 8.4464 16.2424 10.5894C15.8294 12.7324 13.7574 14.1344 11.6144 13.7224C9.47141 13.3094 8.06941 11.2374 8.48141 9.09441M14.2294 21.0464C13.8174 23.1894 11.7454 24.5924 9.60242 24.1794H9.60141C7.45841 23.7664 6.05641 21.6944 6.46841 19.5514C6.88141 17.4084 8.95344 16.0064 11.0964 16.4184C13.2384 16.8324 14.6414 18.9044 14.2294 21.0464ZM15.9074 17.8484C14.9544 17.6644 14.3314 16.7444 14.5144 15.7914C14.6984 14.8384 15.6184 14.2154 16.5714 14.3984C17.5244 14.5824 18.1474 15.5024 17.9644 16.4554C17.7804 17.4084 16.8604 18.0314 15.9074 17.8484ZM24.1464 22.9564C23.7314 25.0984 21.6604 26.4994 19.5184 26.0864C17.3754 25.6734 15.9734 23.6014 16.3854 21.4584C16.7984 19.3154 18.8704 17.9134 21.0134 18.3254C23.1564 18.7384 24.5584 20.8104 24.1464 22.9534M21.5314 15.6304C19.3874 15.2174 17.9854 13.1454 18.3984 11.0014C18.8114 8.85841 20.8834 7.45641 23.0264 7.86841C25.1704 8.28141 26.5724 10.3534 26.1594 12.4974C25.7474 14.6404 23.6754 16.0434 21.5314 15.6304Z"
          fill="#ED145B"
        />
      </g>
      <defs>
        <clipPath id="clip0_9813_210">
          <rect
            width="32.0008"
            height="32"
            fill="white"
            transform="translate(0.25)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

Instagram.displayName = "Instagram";
